import React from 'react';
import { Modal, Button, Alert, Form, ListGroup } from 'react-bootstrap';
import CustomRichTextEditor from './CustomRichTextEditor';

const WhatsappMessageModal = ({
    show,
    onHide,
    onSubmit,
    messageForm,
    onInputChange,
    templates = [],
    submitting,
    error,
    success,
}) => {
    const today = new Date();
    const minSendDate = today.toISOString().split('T')[0];

    const handleBodyChange = (html) => {
        const syntheticEvent = { target: { name: 'body', value: html } };
        onInputChange(syntheticEvent);
    };

    const handleSelectTemplate = (tpl) => {
        const syntheticEvent = { target: { name: 'body', value: tpl?.body || '' } };
        onInputChange(syntheticEvent);
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Form onSubmit={onSubmit}>
                <Modal.Header closeButton style={{ direction: 'rtl', textAlign: 'right' }}>
                    <Modal.Title>Add Message</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ direction: 'rtl', textAlign: 'right' }}>
                    {error && (
                        <Alert variant="danger" className="mb-3">
                            <i className="fas fa-exclamation-circle me-2"></i>
                            {error}
                        </Alert>
                    )}
                    {success && (
                        <Alert variant="success" className="mb-3">
                            <i className="fas fa-check-circle me-2"></i>
                            {success}
                        </Alert>
                    )}

                    {Array.isArray(templates) && templates.length > 0 && (
                        <Form.Group className="mb-3">
                            <Form.Label>Templates</Form.Label>
                            <ListGroup style={{ maxHeight: 180, overflowY: 'auto' }}>
                                {templates.map((tpl) => (
                                    <ListGroup.Item
                                        key={tpl.id}
                                        as="button"
                                        type="button"
                                        action
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleSelectTemplate(tpl);
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="fw-semibold">{tpl.name}</div>
                                            {tpl.type ? <small className="text-muted">{tpl.type}</small> : null}
                                        </div>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                            <Form.Text className="text-muted">
                                Select a template to fill the message body.
                            </Form.Text>
                        </Form.Group>
                    )}

                    <Form.Group className="mb-3">
                        <Form.Label>Message</Form.Label>
                        <CustomRichTextEditor
                            value={messageForm?.body || ''}
                            onChange={handleBodyChange}
                            placeholder="Type the message to send"
                            style={{ minHeight: '180px' }}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Date to send</Form.Label>
                        <Form.Control
                            type="date"
                            name="time_to_send"
                            value={messageForm?.time_to_send || ''}
                            onChange={onInputChange}
                            min={minSendDate}
                            required
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer style={{ direction: 'rtl', textAlign: 'right' }}>
                    <Button variant="secondary" onClick={onHide} disabled={submitting}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        type="submit"
                        disabled={submitting || !(String(messageForm?.body || '').trim())}
                    >
                        {submitting ? 'Saving...' : 'Save'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default WhatsappMessageModal;
